import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import {
  ActivityCard,
  ActivityCardWrapper,
  AttendanceRegister,
  AttendanceRegisterTitle,
  ActivityTitle,
  AddAttempt,
  ConfirmWrapper,
  Infos,
  Legend,
  LegendAndCard,
  QuizButton,
  SessionBlockContainer,
  SessionTitle,
  SessionTitleWrapper,
  SortingWrapper,
  TimeContainer,
  UserCard,
  UserCardWrapper,
} from './style';
import {
  CTA,
  Checkbox,
  CustomInput,
  CustomSelect,
  Icon,
  Inline,
  NoResult,
  Text,
} from '../../../ui/atoms';
import SortBy from '../../../ui/atoms/SortBy';
import theme from '../../../ui/theme';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { MODAL_OPEN } from '../../redux/actions';
import { ModalSessionResultsId } from '../../../ui/atoms/Modals/ModalSessionResults';
import {
  QUIZ_ATTEMPTS_SET,
  QUIZ_VISIBILITY_SET,
  SESSION_USERS_GET,
  USERS_ATTENDANCE_SET,
} from '../../redux/actions/liveEvent';
import { getFilterLabel, getSortingOptions } from '../../../utils/labels';
import { formatActivityInfo, timestampToDate } from '../../../utils/common';
import Pagination from '../../../ui/atoms/Pagination';
import { StickyFiltersWrapper } from '../../../ui/atoms/CTA/style';
import { ModalFiltersId } from '../../../ui/atoms/Modals/ModalFilters';

export const EVENT_USER_SORT_OPTS = [
  'presence_asc',
  'presence_desc',
  'alphabetical_asc',
  'alphabetical_desc',
  'quiz_result_asc',
  'quiz_result_desc',
  'quiz_status_asc',
  'quiz_status_desc',
];

const SessionBlock = ({
  mediaIsPhone,
  isSupervisor,
  session = {},
  sessionUsers,
  modalOpen,
  getSessionUsers,
  setUserAttendance,
  addAttempt,
  handleQuizVisibility,
}) => {
  const { event_id } = useParams();
  // filters
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();

  const [activity_id, setActivityId] = useState(null);
  const [activities, setActivities] = useState([]);
  const [attendingUsers, setAttendingUsers] = useState([]);
  const [initialAttendingUsers, setInitialAttendingUsers] = useState([]);
  const [users, setUsers] = useState({});
  const { quiz_data } = session;

  useEffect(() => {
    const attendanceActivities = session?.activities?.filter(
      // TYPO coming from BE
      (a) =>
        a.attendance === 'with_attendance' ||
        a.attendance === 'with_attendace' ||
        a?.type === 'activity_session_in_place_room'
    );
    if (attendanceActivities?.length === 1) {
      const activityId = attendanceActivities[0]?.id;
      setActivityId(activityId);
    } else setActivities(attendanceActivities);
  }, [session]);

  const handlegetSessionUsers = (page) => {
    if (!activity_id) return;
    const parsedFilters = {
      ...selectedFilters,
      page,
    };
    getSessionUsers({
      session_id: session?.session_id,
      activity_id,
      filters: parsedFilters,
    });
  };

  useEffect(() => {
    handlegetSessionUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters, activity_id]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handlegetSessionUsers(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  // user attendandance
  const handleSetAttendance = (userId) => {
    const newUsers = [...attendingUsers];
    const index = newUsers.findIndex((u) => userId === u);
    if (index < 0) newUsers.push(userId);
    else newUsers.splice(index, 1);
    setAttendingUsers(newUsers);
  };

  useEffect(() => {
    if (activity_id && sessionUsers && sessionUsers[activity_id]) {
      setUsers(sessionUsers[activity_id]);
    }
  }, [activity_id, sessionUsers]);

  useEffect(() => {
    if (users?.data?.length > 0) {
      const attUserIds = users.data
        .filter((u) => u?.presence)
        .map((u) => u?.id);
      setAttendingUsers(attUserIds || []);
      setInitialAttendingUsers(attUserIds || []);
    }
  }, [users?.data]);

  return (
    <SessionBlockContainer>
      <SessionTitleWrapper>
        <SessionTitle>
          <Text type="h2">
            Sessione{' '}
            {session?.session_name ? `“${session?.session_name}” ` : ''}
            {session?.session_number}
          </Text>
          {/* //? check if all the activities in the session are past */}
          {(session?.activities || []).every((activity) => {
            const info = formatActivityInfo(activity);
            return info.tsEnd < dayjs().unix();
          }) && (
            <Inline columnGap="16px">
              <Text type="b2" color="#03603F">
                Sessione terminata
              </Text>
              <Icon
                type="check-circle"
                clickable={false}
                stroke="#03603F"
                size={24}
              />
            </Inline>
          )}
        </SessionTitle>
        <CTA
          type="tertiary"
          btnText="Risultati sessione"
          icon="book-open-01"
          onClick={() =>
            modalOpen(ModalSessionResultsId, {
              sessionId: session?.session_id,
              sessionName: session?.session_name,
              sessionNumber: session?.session_number,
            })
          }
        />
      </SessionTitleWrapper>
      <ActivityCardWrapper>
        {/* SESSION ACTIVITIES */}
        {(session?.activities || []).map((activity, ai) => {
          const info = formatActivityInfo(activity);
          return (
            <ActivityCard
              key={`activity-${ai}`}
              className={ai > 0 ? 'is-copy' : ''}
            >
              <ActivityTitle>
                <Text
                  type="h2"
                  className={session?.activities.length > 1 ? 'is-multi' : ''}
                >
                  Attività 1
                </Text>
                {info?.isLive ? (
                  <Inline columnGap="16px">
                    <Text type="b2" color="#003366">
                      Attività in corso
                    </Text>
                    <Icon
                      type="monitor-03"
                      clickable={false}
                      stroke="#003366"
                      size={24}
                    />
                  </Inline>
                ) : info?.tsEnd < dayjs().unix() ? (
                  <Inline columnGap="16px">
                    <Text type="b2" color="#03603F">
                      Attività terminata
                    </Text>
                    <Icon
                      type="check-circle"
                      clickable={false}
                      stroke="#03603F"
                      size={24}
                    />
                  </Inline>
                ) : null}
              </ActivityTitle>
              <Infos>
                <div>
                  <Text type="h3" mb={8}>
                    Tipologia attività
                  </Text>
                  <Text type="b4">{getFilterLabel(activity?.type)}</Text>
                </div>
                <div>
                  <Text type="h3" mb={8}>
                    Titolo attività
                  </Text>
                  <Text type="b4">{activity?.title}</Text>
                </div>
                <div>
                  <Text type="h3" mb={8}>
                    Data
                  </Text>
                  <Text type="b4">{timestampToDate(info?.tsStart)}</Text>
                </div>

                <TimeContainer>
                  <div>
                    <Text type="h3" mb={8}>
                      Ora inizio
                    </Text>
                    <Text type="b4">{activity?.start_time}</Text>
                  </div>
                  <div>
                    <Text type="h3" mb={8}>
                      Ora fine
                    </Text>
                    <Text type="b4">{activity?.end_time}</Text>
                  </div>
                </TimeContainer>

                <div>
                  <Text type="h3" mb={8}>
                    Registrazione presenze
                  </Text>
                  <Text type="b4">{getFilterLabel(activity?.attendance)}</Text>
                </div>
                <div>
                  <Text type="h3" mb={8}>
                    Tipologia accesso
                  </Text>
                  <Text type="b4">{getFilterLabel(activity?.access_type)}</Text>
                </div>
                {activity?.available_places > 0 && (
                  <div>
                    <Text type="h3" mb={8}>
                      Posti disponibili
                    </Text>
                    <Text type="b4">
                      {activity?.available_places || 0} posti disponibili
                    </Text>
                  </div>
                )}
                <div>
                  <Text type="h3" mb={8}>
                    Utenti registrati
                  </Text>
                  <Text type="b4">
                    {activity?.registered_number || 0} utenti
                  </Text>
                </div>
              </Infos>
            </ActivityCard>
          );
        })}
        {/* SESSION QUIZ */}
        {session?.session_quiz_id > 0 && (
          <ActivityCard>
            <ActivityTitle>
              <Text type="h2">Attività 2</Text>
              {session?.session_quiz_visibility && (
                <Inline columnGap="16px">
                  <Text type="b2" color="#003366">
                    Attività in corso
                  </Text>
                  <Icon
                    type="monitor-03"
                    clickable={false}
                    stroke="#003366"
                    size={24}
                  />
                </Inline>
              )}
            </ActivityTitle>
            <Infos>
              <div>
                <Text type="h3" mb={8}>
                  Tipologia attività
                </Text>
                <Text type="b4">Quiz</Text>
              </div>
              <div>
                <Text type="h3" mb={8}>
                  Titolo attività
                </Text>
                <Text type="b4">{quiz_data?.title}</Text>
              </div>
              <div>
                <Text type="h3" mb={8}>
                  Percentuale di superamento
                </Text>
                <Text type="b4">{quiz_data?.min_perc_to_pass || 0}%</Text>
              </div>
              <div>
                <Text type="h3" mb={8}>
                  Numero di tentativi
                </Text>
                <Text type="b4">{session?.session_quiz_tentatives}</Text>
              </div>
              <div>
                <Text type="h3" mb={8}>
                  Durata
                </Text>
                <Text type="b4">{quiz_data?.duration} min</Text>
              </div>
            </Infos>
            <QuizButton>
              <Text type="b3">
                Abilita il quiz alla fine della classe virtuale o dal vivo.
              </Text>
              <CTA
                type={
                  session?.session_quiz_visibility ? 'secondary' : 'primary'
                }
                btnText={
                  session?.session_quiz_visibility
                    ? 'Disabilita quiz'
                    : 'Abilita quiz'
                }
                fullsize={mediaIsPhone}
                onClick={() =>
                  handleQuizVisibility({
                    session_id: session?.session_id,
                    visibility: !session?.session_quiz_visibility,
                    event_id,
                  })
                }
              />
            </QuizButton>
          </ActivityCard>
        )}
      </ActivityCardWrapper>
      <AddAttempt>
        <Text type="b3">
          Per permettere agli utenti di avere un ulteriore tentativo per il
          completamento del quiz, clicca su 'aggiungi tentativo'.
        </Text>
        {/* //? "Aggiungi tentativo" is global, and not user-based as figma (mobile) seems to imply */}
        <CTA
          type="tertiary"
          btnText="Aggiungi tentativo"
          icon="plus-square"
          onClick={() =>
            addAttempt({
              session_id: session?.session_id,
              tentatives: session.session_quiz_tentatives + 1,
              event_id,
            })
          }
        />
      </AddAttempt>
      {/* //? check if any activities in the session are live */}
      {(session?.activities || []).some((activity) => {
        return (
          activity?.attendance === 'with_attendance' ||
          activity?.type === 'activity_session_in_place_room'
        );
      }) && (
        <AttendanceRegister>
          <AttendanceRegisterTitle>
            <Text type="h3">Registro attività</Text>
            <Text type="b3">
              Dopo aver fatto l’appello, conferma le presenze per salvarle a
              sistema.
            </Text>
          </AttendanceRegisterTitle>
          {mediaIsPhone ? (
            <>
              <StickyFiltersWrapper
                mb={16}
                stickyPosition={0}
                bgColor="#eff5fb"
              >
                <CustomInput
                  size={mediaIsPhone ? 's' : 407}
                  placeholder="Cosa vuoi cercare?..."
                  isSearch
                  value=""
                  icon="search-sm"
                  isClearable
                  onChange={(v) => setSearchValue(v)}
                  onClickIcon={onClickSearch}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') onClickSearch();
                  }}
                />
                <CTA
                  btnText="Filtri"
                  type="secondary"
                  compact
                  onClick={() =>
                    modalOpen(ModalFiltersId, {
                      sorting: getSortingOptions(EVENT_USER_SORT_OPTS),
                      activeFilters: selectedFilters,
                      onClickAlt: (newFilters) =>
                        setSelectedFilters(newFilters),
                    })
                  }
                />
              </StickyFiltersWrapper>
              <Text type="b3" mb={24}>
                {users?.pager?.total_items || 0} utenti
              </Text>
            </>
          ) : (
            <>
              <CustomInput
                size={mediaIsPhone ? 's' : 407}
                placeholder="Cosa vuoi cercare?..."
                isSearch
                value=""
                icon="search-sm"
                isClearable
                onChange={(v) => setSearchValue(v)}
                onClickIcon={onClickSearch}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') onClickSearch();
                }}
              />
              <SortingWrapper>
                <Text type="b3">{users?.pager?.total_items || 0} utenti</Text>
                <SortBy
                  options={getSortingOptions(EVENT_USER_SORT_OPTS)}
                  onChange={(v) => {
                    setSelectedFilters({
                      ...selectedFilters,
                      sort_by: v?.value,
                    });
                  }}
                />
              </SortingWrapper>
            </>
          )}
          {activities?.length > 0 && (
            <div className="mb-3">
              <Text type="h3" mb={8}>
                Seleziona una delle attività
              </Text>
              <CustomSelect
                size="m"
                options={activities.map((a) => ({
                  label: a.title,
                  value: a.id,
                }))}
                onChange={({ value }) => {
                  setActivityId(value);
                }}
              />
            </div>
          )}
          {users?.data?.length > 0 ? (
            <UserCardWrapper>
              {(users?.data || []).map((user, i) => (
                <LegendAndCard
                  key={`event-${i}`}
                  gridTemplateColumns="2.5fr 1fr 1fr 1fr 1.5fr 1.5fr"
                  gridTemplateRows="24px 24px 24px 24px 32px 32px"
                >
                  {(i === 0 || mediaIsPhone) && (
                    <Legend>
                      <Text type="statistics-heading">Nome</Text>
                      <Text type="statistics-heading">Presenza</Text>
                      <Text type="statistics-heading">Stato quiz</Text>
                      <Text type="statistics-heading">Punteggio</Text>
                      <Text type="statistics-heading">
                        Data e ora inizio quiz
                      </Text>
                      <Text type="statistics-heading">
                        Data e ora fine quiz
                      </Text>
                    </Legend>
                  )}
                  <UserCard>
                    <Text type="h3">
                      {user?.name} {user?.surname}
                    </Text>
                    <Checkbox
                      label="presenza"
                      hiddenLabel
                      name="attendance"
                      onChange={() => handleSetAttendance(user?.id)}
                      checked={attendingUsers?.includes(user?.id)}
                      disabled={
                        initialAttendingUsers?.includes(user?.id) &&
                        !isSupervisor
                      }
                    />
                    <Text type="b4">{getFilterLabel(user?.quiz_status)}</Text>
                    <Text type="b4">
                      {Number(user?.percentage || 0).toFixed(2) * 100}%
                    </Text>
                    <Text type="b4" color={theme().colors.primaryDarkGray700}>
                      {timestampToDate(
                        user?.quiz_start_time,
                        'DD/MM/YYYY HH:mm'
                      )}
                    </Text>
                    <Text type="b4" color={theme().colors.primaryDarkGray700}>
                      {timestampToDate(user?.quiz_end_time, 'DD/MM/YYYY HH:mm')}
                    </Text>
                  </UserCard>
                </LegendAndCard>
              ))}
            </UserCardWrapper>
          ) : (
            <NoResult />
          )}
          {users?.pager && (
            <Pagination
              pt={mediaIsPhone ? 32 : 48}
              pb={mediaIsPhone ? 8 : 24}
              pager={users?.pager}
              callBack={loadMore}
              setItemsPerPage={setItemsPerPage}
              noBg
            />
          )}
          <ConfirmWrapper>
            {/* //? "Presenze confermate" badge is ko (always show btn) */}
            <CTA
              btnText="Conferma presenze"
              onClick={() => {
                const add_users = attendingUsers.filter(
                  (au) => !initialAttendingUsers?.includes(au)
                );
                const remove_users = initialAttendingUsers.filter(
                  (iau) => !attendingUsers?.includes(iau)
                );
                setUserAttendance({
                  session_id: session?.session_id,
                  activity_id,
                  body: {
                    add_users,
                    remove_users,
                  },
                });
              }}
              fullsize={mediaIsPhone}
            />
          </ConfirmWrapper>
        </AttendanceRegister>
      )}
    </SessionBlockContainer>
  );
};

SessionBlock.propTypes = {
  session: PropTypes.object,
  // HOC: mediaQueries
  mediaIsPhone: PropTypes.bool,
  // HOC: state
  isSupervisor: PropTypes.bool,
  sessionUsers: PropTypes.object,
  // HOC: dispatch
  getSessionUsers: PropTypes.func,
  modalOpen: PropTypes.func,
  setUserAttendance: PropTypes.func,
  addAttempt: PropTypes.func,
  handleQuizVisibility: PropTypes.func,
};

export default connect(
  (state) => {
    const { isSupervisor } = state.user;
    const { sessionUsers } = state.liveEvent;
    return { isSupervisor, sessionUsers };
  },
  (dispatch) => ({
    modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    getSessionUsers: ({ session_id, activity_id, filters }) =>
      dispatch({
        type: SESSION_USERS_GET._REQUEST,
        session_id,
        activity_id,
        filters,
      }),
    setUserAttendance: ({ session_id, activity_id, body }) =>
      dispatch({
        type: USERS_ATTENDANCE_SET._REQUEST,
        session_id,
        activity_id,
        body,
      }),
    addAttempt: ({ session_id, tentatives, event_id }) =>
      dispatch({
        type: QUIZ_ATTEMPTS_SET._REQUEST,
        session_id,
        tentatives,
        event_id,
      }),
    handleQuizVisibility: ({ session_id, visibility, event_id }) =>
      dispatch({
        type: QUIZ_VISIBILITY_SET._REQUEST,
        session_id,
        visibility,
        event_id,
      }),
  })
)(withMediaQueries(SessionBlock));
